<template>
    <div class="message-wrapper" :title="timestampText">
        <!-- <transition name="fade"> -->
        <div :id="id" class="message scheduled shadow">
            <!-- Tapping anywhere opens the menu; "View image" in it opens the viewer. -->
            <img v-if="imageSrc" :src="imageSrc" class="scheduled-image" :alt="$t('scheduled.image')">
            <div v-else>{{ displayText }}</div>
        </div>
        <div class="date-wrapper">
            <div class="date mdl-color-text--grey-500">
                {{ timestampText }}
            </div>
        </div>
        <ul id="message-menu"
            class="mdl-menu mdl-js-menu mdl-js-ripple-effect mdl-menu--bottom-right" :data-mdl-for="id"
        >
            <li v-if="imageSrc" class="mdl-menu__item" @click="openImage">
                {{ $t('scheduled.view_image') }}
            </li>
            <li class="mdl-menu__item" @click="editMessage">
                Edit Message
            </li>
            <li class="mdl-menu__item" @click="deleteMessage">
                Delete Message
            </li>
        </ul>
        <!-- </transition> -->
    </div>
</template>

<script>

import store from '@/store/';
import { Util, Api } from '@/utils';
import { componentHandler } from '@/lib/material.js';
import { isScheduledImage, loadScheduledImage } from './scheduledMedia';

export default {
    name: 'ScheduledMessageItem',
    props: [ 'messageData' ],

    data () {
        return {
            id: this.messageData.device_id,
            to: this.messageData.to,
            data: this.messageData.data,
            title: this.messageData.title,
            timestamp: this.messageData.timestamp,
            mime_type: this.messageData.mime_type,
            repeat: this.messageData.repeat || 0,
            menu: null,
            imageSrc: null,
            imageFailed: false,
        };
    },

    computed: {
        isImage () {
            return isScheduledImage(this.messageData);
        },
        displayText () {
            if (this.isImage) {
                return this.imageFailed ? this.$t('scheduled.image_unavailable') : this.$t('scheduled.image_loading');
            } else if (this.mime_type != 'text/plain') {
                return this.$t('scheduled.media');
            } else {
                return this.data;
            }
        },
        timestampText () {
            const time = new Date(this.timestamp).toLocaleString();
            const name = this.title;

            if (this.repeat == 0) {
                return `${name} - ${time}`;
            } else {
                let repeatText = "";
                switch (this.repeat) {
                    case 1:
                        repeatText = this.$t('scheduled.repeat.daily');
                        break;
                    case 2:
                        repeatText = this.$t('scheduled.repeat.weekly');
                        break;
                    case 3:
                        repeatText = this.$t('scheduled.repeat.monthly');
                        break;
                    case 4:
                        repeatText = this.$t('scheduled.repeat.yearly');
                        break;
                }

                return `${name} - ${time} (${repeatText})`;
            }
        }
    },

    mounted () {
        let menu_el = this.$el.querySelector("#message-menu");
        componentHandler.upgradeElement(menu_el);

        this.menu = menu_el.MaterialMenu;

        // Shows the image instead of the "Media" label once it has downloaded.
        if (this.isImage) {
            loadScheduledImage(this.messageData)
                .then(src => {
                    this.imageSrc = src;
                })
                .catch(() => {
                    this.imageFailed = true;
                });
        }
    },

    methods: {
        deleteMessage () {
            Api.scheduledMessages.delete(this.id)
                .then(() => {
                    Util.snackbar("Deleted Message to " + this.title);
                }).catch(() => {
                    Util.snackbar("Failed to delete message");
                });
        },

        openImage () {
            Util.displayImage(this.$store.state.media_loader, this.data, this.mime_type);
        },

        // EditScheduledMessage looks the message up by id, so it also works after a page reload.
        editMessage () {
            this.$router.push({
                name: 'edit-scheduled-message', params: { messageId: String(this.id) }
            });
        }
    }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../../assets/scss/_vars.scss";

    .date-wrapper {
        clear: both;

        .date {
            float: right;
            margin-right: 36px;
        }
    }

    .message-wrapper {
        user-select: text;
        clear: both;
        display: block;
        position: relative;

        .message {
            position: relative;
            padding: 16px;
            margin: 4px 8px 4px 8px;
            max-width: 310px;
            border-radius: 15px;
            overflow-wrap: break-word;
            word-wrap: break-word;
            min-width: 18px;
        }

        .message:hover {
            cursor: pointer;
        }

        .message:after {
            position: absolute;
            bottom: -20px;
            left: 50%;
            border-style: solid;
            display: block;
            top: 0px;
            bottom: auto;
        }

        .scheduled-image {
            display: block;
            max-width: 100%;
            max-height: 240px;
            border-radius: 8px;
        }

        .scheduled {
            float: right;
            color: black;
            margin-right: 28px;
            background: #fff;

            &:after {
                right: -8px;
                border-width: 15px 10px 0 0;
                border-color: #fff transparent;
            }

            a {
                color: black;
            }
        }

        @media screen and (min-width: 600px) {
            .message {
                max-width: 372px;
            }
        }

        @media screen and (min-width: 720px) {
            .message {
                max-width: 436px;
            }
        }
    }

    body.dark {
        .scheduled {
            background: $bg-darker;
            color: #fff;

            &:after {
                border-color: $bg-darker transparent;
            }
        }
    }

</style>
